const Footer = () => {
  const handleWhatsApp = () => {
    window.open(
      'https://wa.me/5200000000000?text=Hola%2C%20me%20interesa%20cotizar%20pantallas%20para%20mi%20evento',
      '_blank'
    );
  };

  const navLinks = [
    { label: 'Inicio', href: '#hero' },
    { label: 'Nosotros', href: '#about' },
    { label: 'Servicios', href: '#services' },
    { label: 'Galería', href: '#gallery' },
  ];

  const socialLinks = [
    { icon: 'ri-instagram-line', href: '#', label: 'Instagram' },
    { icon: 'ri-facebook-circle-line', href: '#', label: 'Facebook' },
    { icon: 'ri-tiktok-line', href: '#', label: 'TikTok' },
    { icon: 'ri-youtube-line', href: '#', label: 'YouTube' },
  ];

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-[#0d0d0d] border-t border-cyan-500/20">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Column 1: Brand */}
          <div className="flex flex-col">
            <img
              src="https://public.readdy.ai/ai/img_res/6615a8d5-90c0-445c-968a-103c6dfeb108.png"
              alt="Astro Screen"
              className="h-12 w-auto object-contain mb-4 self-start"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-6 max-w-xs">
              Especialistas en renta de pantallas LED para expos, ferias y eventos. Transformamos tu visión en una experiencia visual extraordinaria.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-700 text-gray-400 hover:border-cyan-400 hover:text-cyan-400 transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Column 2: Navigation */}
          <div className="flex flex-col">
            <h4 className="text-cyan-400 font-semibold text-base uppercase tracking-wider mb-6">
              <a href="#hero">Navegación</a>
            </h4>
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <button
                  key={link.label}
                  onClick={() => handleNav(link.href)}
                  className="text-gray-400 hover:text-cyan-400 text-sm text-left transition-colors duration-300 cursor-pointer whitespace-nowrap w-fit"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Column 3: Contact */}
          <div className="flex flex-col">
            <h4 className="text-cyan-400 font-semibold text-base uppercase tracking-wider mb-6">
              <a href="#footer">Contacto</a>
            </h4>
            <div className="flex flex-col gap-4 mb-6">
              <a
                href="tel:+525525261379"
                className="flex items-center gap-3 text-white hover:text-cyan-400 transition-colors duration-300 cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-cyan-500/15 border border-cyan-500/30 flex-shrink-0">
                  <i className="ri-phone-line text-cyan-400 text-sm" />
                </div>
                <span className="text-lg font-bold">+52 55 2526 1379</span>
              </a>
              <a
                href="mailto:contacto@astroscreen.mx"
                className="flex items-center gap-3 text-gray-400 hover:text-cyan-400 transition-colors duration-300 cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-cyan-500/15 border border-cyan-500/30 flex-shrink-0">
                  <i className="ri-mail-line text-cyan-400 text-sm" />
                </div>
                <span className="text-sm">ethandeform@gmail.com </span>
              </a>
              <div className="flex items-center gap-3 text-gray-400">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-cyan-500/15 border border-cyan-500/30 flex-shrink-0">
                  <i className="ri-map-pin-line text-cyan-400 text-sm" />
                </div>
                <span className="text-sm">México, cobertura nacional</span>
              </div>
            </div>
            <button
              onClick={handleWhatsApp}
              className="flex items-center justify-center gap-2 bg-gradient-to-r from-cyan-500 to-sky-600 text-white font-bold text-sm px-6 py-3 rounded-full hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap w-fit"
            >
              <i className="ri-whatsapp-line text-lg" />
              Escribir por WhatsApp
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 bg-black">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-600 text-xs text-center sm:text-left">
            &copy; {new Date().getFullYear()} Astro Screen. Todos los derechos reservados.
          </p>
          <p className="text-gray-700 text-xs">
            Renta de pantallas LED para expos y eventos en México
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
